<div class="app-page">

    Game overview for team
<div id="GameRanking"></div>


    <a [routerLink]="['/load/game_feed', this.TeamId]">view all games</a>
    

</div>